import { FiMoon, FiSun } from "react-icons/fi";
import { useTheme } from "../../context/ThemeProvider";

const ThemeToggle = () => {
  const { darkMode, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      aria-label={`Switch to ${darkMode ? "light" : "dark"} mode`}
      className="mt-10 md:mt-0 hover:transform-none relative inline-flex h-6 w-11 ml-4 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-[var(--primary)] focus:ring-offset-2"
      style={{
        backgroundColor: darkMode ? "var(--primary)" : "#d1d5db",
      }}
    >
      <span
        className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-lg transition-transform ${
          darkMode ? "translate-x-[21px]" : "translate-x-[2px]"
        }`}
      >
        <span className="absolute inset-0 flex items-center justify-center">
          {darkMode ? (
            <FiMoon className="text-xs text-[#10130D]" aria-hidden="true" />
          ) : (
            <FiSun className="text-xs text-[var(--primary)]" aria-hidden="true" />
          )}
        </span>
      </span>
    </button>
  );
};

export default ThemeToggle;
